import React from "react";
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { ConstructionCategoryViewController, ConstructionCategoryViewControllerDelegate } from "../../Screen/ConstructionCategory/ConstructionCategoryViewController";
import { ConstructionCategoryViewModel } from "../../Screen/ConstructionCategory/ConstructionCategoryViewModel";
import { TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import ProtectedRoute from "../../Components/ProtectedRoute";


export class ConstructionCategoryCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, ConstructionCategoryViewControllerDelegate {
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepcategoriaconstrucao")
        return (<ProtectedRoute requiredPermissions={['prop.cat_construcao.*']} path="/:base/categoria-construcao" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.cat_construcao.adicionar',
                    edit: 'prop.cat_construcao.editar',
                    delete: 'prop.cat_construcao.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Categoria Construção"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new ConstructionCategoryViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.cat_construcao.adicionar', 'prop.cat_construcao.editar']} path="/:base/categoria-construcao/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<ConstructionCategoryViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepcategoriaconstrucao") {
            navigation.history.push(`categoria-construcao/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepcategoriaconstrucao") {
            navigation.history.push(`categoria-construcao/cad/${idSelection}`);
            return;
        }
    }

}
